<template>
  <div data-dot class="expand-block" ref="dotComponentRef">
    <transition name="button">
      <button
        @click="removeCurrentDot"
        class="icon-cross remove-dot"
        type="button"
        v-tooltip.top-center="{
          content: 'Удалить точку доставки',
          trigger: 'hover click',
        }"
        v-if="order.dots.length > 2 && getDotIndex(dot)"
      ></button>
    </transition>
    <div class="block">
      <div class="block-title center">
        <h2>
          {{
            getDotIndex(dot) === 0
              ? computeSenderName
              : order.dots.length === 2
              ? 'Получатель'
              : `Получатель № ${getDotIndex(dot)}`
          }}
        </h2>
      </div>
      <div class="sender-info">
        <AddressComponent :dot="dot" ref="addressRefComponent" />
        <MetroComponent v-if="base.isAdmin && !!+selectedCity.anyMetro" :dot="dot" />
        <DetailsComponent :dot="dot" />

        <div v-if="isShowCashBlock" class="accentuated-alert accentuated-alert__with-icon">
          <label class="label-checkbox unselectable">
            <input type="checkbox" v-model="cash" name="" id="" />
            <div>Получить оплату за товар</div>
          </label>
          <i
            class="icon-tooltip"
            v-tooltip.top-center="{
              content: cashOnDotTooltipMessage,
              trigger: 'click hover',
            }"
          ></i>
        </div>

        <AdditionInfoComponent :isShow="base.isAdmin || additionInfo" :dot="dot" />
        <span
          class="addition-info-switcher unselectable"
          v-if="!base.isAdmin"
          @click="additionInfo = !additionInfo"
          @keypress="additionInfo = !additionInfo"
          >{{ !additionInfo ? '+ Доп. информация' : '- Скрыть дополнительные поля' }}</span
        >
      </div>
    </div>
    <ItemsListComponent v-if="dot.items.length" :dot="dot" />
    <DeliveryExtraPay v-if="dot.items.length && !isBuyout && !isAnonimousForm" :dot="dot" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import AddressComponent from './Dot/AddressComponent.vue'
import DetailsComponent from './Dot/DetailsComponent.vue'
import ItemsListComponent from './Dot/ItemsListComponent.vue'
import DeliveryExtraPay from './Dot/DeliveryExtraPay.vue'
import MetroComponent from './Dot/MetroComponent.vue'
import AdditionInfoComponent from './Dot/AdditionInfoComponent.vue'

export default {
  name: 'DotComponent',
  props: {
    dot: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddressComponent,
    DetailsComponent,
    ItemsListComponent,
    DeliveryExtraPay,
    MetroComponent,
    AdditionInfoComponent,
  },
  data: () => ({
    additionInfo: false,
  }),

  computed: {
    // ...mapState(['dotSuggestions']),
    ...mapState(GENERAL_STORE, ['base', 'order', 'user']),
    ...mapGetters(GENERAL_STORE, [
      'isBuyout',
      'getDotIndex',
      'selectedCity',
      'formattedPaymentMethods',
      'availablePaymentMethods',
      'isYandexForm',
      'isAnonimousForm',
    ]),
    computeSenderName() {
      return this.isBuyout ? 'Магазин' : 'Отправитель'
    },
    thisDotIndex() {
      return this.getDotIndex(this.dot)
    },
    isShowCashBlock() {
      if (this.thisDotIndex && !this.isBuyout) {
        return !(this.isYandexForm && !this.user.isLegalEntity)
      }

      return false
    },

    addressFieldRef() {
      return this.$refs.addressRefComponent.addressFieldRef
    },

    cash: {
      get() {
        return this.dot.cash
      },
      set(value) {
        this.updateDot({
          dot: this.dot,
          data: {
            key: 'cash',
            value: +value,
          },
        })

        if (!value) {
          this.updateDot({
            dot: this.dot,
            data: { key: 'deliveryExtraPay', value: 0 },
          })
        }

        this.calculatePrice()
      },
    },
    cashOnDotTooltipMessage() {
      return 'При вручении груза курьер принимает денежную сумму ("Ценность") от получателя (покупателя), которая пересылается заказчику выбранным способом.'
    },
  },

  watch: {
    dot: {
      handler() {
        this.calculatePrice()
      },
      deep: true,
    },
  },

  methods: {
    ...mapMutations(GENERAL_STORE, ['removeDot', 'updateDot', 'setPaymentMethod']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),

    removeCurrentDot() {
      this.removeDot(this.dot)
      this.calculatePrice()
    },
    scrollToField() {
      this.$refs.dotComponentRef.scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    focusAddressInputField() {
      this.addressFieldRef.focus()
    },
  },

  created() {
    if (this.dot.comment) this.additionInfo = true
  },
  mounted() {
    this.$nextTick(() => {
      if (this.thisDotIndex > 1 && !this.base.isEdit && !this.base.isRestart) {
        this.focusAddressInputField()
        this.scrollToField()
      }
    })
  },
}
</script>

<style lang="scss" scoped>
.expand-block {
  transition: all 0.6s;
}

.button-enter,
.button-leave-to {
  opacity: 0;
}

.button-enter-to,
.button-leave {
  opacity: 1;
}

.button-enter-active,
.button-leave-active {
  transition: all 0.6s;
}

.dot-btn {
  position: relative;

  width: 18px;
  height: 18px;
  margin-left: 5px;

  font-size: 20px;
  color: #fff;

  background-color: #c9ced2;
  border: none;
  border-radius: 50%;

  transition: all 0.6s ease-out;

  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-52%, -45%);

    font-family: PeshkarikiFont, sans-serif !important;
    font-size: 11px;
  }

  &:hover {
    background-color: #787a7c;
  }
}

.save {
  &::before {
    content: '\E962';
  }
}

.close {
  &::before {
    content: '\ea0f';
  }
}

.invalid-text.enough-time-error {
  margin-top: 0;
  margin-bottom: 7px;

  text-align: right;
}
</style>
